import React, { useRef } from 'react';
import { Col, Offcanvas, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useGetRelatedKeywordsQuery } from '@/app/KeywordTracker/api/keywordsApi';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import { relatedKeywordsColumnConfig } from '@/app/KeywordTracker/config/relatedKeywordsColumnConfig';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import { hideDrawer } from '@/app/common/reducers/drawer';
const RelatedKeywordsDrawer = () => {
  const { data: userInfo } = useGetUserInfoQuery();
  const dispatch = useDispatch();
  const { key, payload } = useSelector(state => state.drawer);
  const { language_code, keyword, location_code } = payload ?? '';
  const { data, isError, isLoading, isFetching } = useGetRelatedKeywordsQuery(
    {
      keyword,
      language_code,
      location_code
    },
    { skip: !keyword || key !== 'related_keywords' }
  );
  const gridRef = useRef(null);
  return (
    <DrawerWrapper
      show={key === 'related_keywords'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0">
            کلمات مرتبط (
            <strong>{keyword ? decodeURIComponent(keyword) : ''}</strong>)
          </h6>
        </div>
      }
    >
      <Row className="mt-2 g-2">
        <Col>
          {!isFetching ? (
            <div ref={gridRef}>
              <AgGridWrapper
                settings={{
                  pagination: false,
                  fullscreen: false,
                  changeHeight: false,
                  resetGrid: false,
                  saveGrid: false
                }}
                columns={relatedKeywordsColumnConfig}
                data={data?.data}
                height="746px"
                // data={fakeDataGen}
              />
            </div>
          ) : (
            <AgGridSkeleton
              height="696px"
              settings={{
                pagination: false,
                fullscreen: false,
                changeHeight: false,
                resetGrid: false,
                saveGrid: false,
                exportBtn: false
              }}
            />
          )}
        </Col>
      </Row>
    </DrawerWrapper>
  );
};

export default RelatedKeywordsDrawer;
